import type { ActiveOrders } from '@/lib/orders/model'
import { apiConfig } from "./client";

export const orderApi = {
  activeOrders: async (signal?: AbortSignal) => {
    const response = await apiConfig.get<ActiveOrders>("/api/front/chef/active-orders", { signal });
    return response;
  },
};
